<template>
    <div class="agreement">
        <div class="agree" v-if="pageShow">
            <div>
                <div class="title">第三方服务及个人信息授权书</div>
                <div class="text">
                    <div class="indent">
                        尊敬的用户，<span class="weight">我们在此特别提醒您认真阅读、充分理解本协议各条款，特别是其中加粗条款等。请您审慎阅读并选择接受或不接受本协议。</span>
                    </div>
                    <div class="indent">
                        为更好地为您提供贷款中介信息咨询服务，<span class="weight">现特以数字电文（即“E签宝”电子签章）点击确认的方式订立本个人信息授权协议</span>，在您和我们之间具有合同上的法律效力，适用于您在本页面下的服务/产品申请活动。
                    </div>
                    <div class="indent weight">
                        本授权协议主要包括以下内容：
                    </div>
                    <div class="indent weight">
                        一、个人信息授权书
                    </div>
                    <div class="indent weight">
                        二、贷款服务方授权书
                    </div>
                    <div class="indent weight">
                        三、个人信息处理规则
                    </div>
                    <div class="indent weight">
                        以下为《个人信息授权书》以及《贷款服务方授权书》，我们再次提示您，请仔细阅读，如同意授权请您点击/勾选“确认”、“同意”、“立即签署”按钮或类似按钮。本协议将通过“E签宝”平台予以存证。
                    </div>
                    <div class="indent weight">
                        一、【个人信息授权书】
                    </div>
                    <div>
                        上海屹零科技有限公司（以下简称“贵司”）：
                    </div>
                    <div class="indent">
                        为便于本人完成借款，本人知悉并同意通过贵司所属的同城借平台向平台合作所列的贷款服务方 {{productName}}
                        （以下简称服务方）申请贷款咨询等服务，贵司为服务方与本人之间的合作提供系统及技术服务，现本人向贵司授权如下：
                    </div>

                    <div class="indent">
                        1、在本人通过同城借平台与服务方接洽的过程中，基于服务方对本人提供咨询服务、进行授信／借款审批及贷前、货中、货后管理的目的，本人同意授权贵司作为同城借平台的系统及技术提供方，对本人信息（包括但不限于姓名，身份证信息，居住地址、生物识别信息、婚婚状况、教育学历信息、工作收入情况、征信情况、银行卡、财产负债信息、网络借贷信息、各网络平台账户信息、联系人信息、电子邮箱等）数据进行收集、存储、使用并将本人上述信息向服务方传输。
                    </div>
                    <div class="indent">
                        2、除上述授权外，贵司及下属同城借平台不得擅自留存、使用、对外披露本人任何信息数据。
                    </div>
                    <div class="indent">
                        3、本授权书有效期自本人签署之日起至本人与服务方之间的贷款咨询服务终止之日止。
                    </div>
                    <div class="indent">
                        4、本人知悉并确认，本授权书以本人确认勾选的形式签署。
                    </div>
                    <div class="indent">
                        5、本人知悉并理解本授权书所有内容的意义及由此产生的法律效力和后果，本人勾选即表示本人自愿做出上述授权。
                    </div>
                    <div>
                        本授权书是本人真实的意思表示，在本人授权范围内引起的后果及法律责任由本人承担！
                    </div>
                    <div>
                        授权人（本人）：{{realName}}
                    </div>
                    <div>
                        身份证号码：{{idCard}}
                    </div>
                    <div>
                        授权日期：{{date}}
                    </div>
                    <div>
                        信贷服务方基础信息表单
                    </div>
                    <div>
                        <table cellpadding="0" cellspacing="8" style="margin: 10px 0px;">
                            <tr style="font-size: 14px;font-weight: bolder;">
                                <td>类型</td>
                                <td>具体产品名称</td>
                                <td>收集个人信息的目的和用途</td>
                                <td>收集个人信息类型</td>
                                <td>收集方式</td>
                            </tr>
                            <tr>
                                <td>贷款服务方</td>
                                <td>{{productName}}</td>
                                <td>贷款推荐及放款审核</td>
                                <td>UID、手机号码、姓名、身份证、工作城市、贷款用途、客户需求金额和期限、职业身份、工资情况、社保、公积金、车辆信息、房产信息、信用卡额度、芝麻分、寿险保单</td>
                                <td>用户主动填写提供</td>
                            </tr>
                        </table>
                    </div>

                    <div class="indent weight">
                        二、【贷款服务方授权书】
                    </div>
                    <div>
                        贷款服务方 {{productName}} （以下简称贵司/我们）：
                    </div>
                    <div class="indent">
                        1、本人明确授权贵司向贵司合作的正规持牌金融机构提供包括但不限于本人姓名、年龄、身份证号、所在城市，申请额度、手机号、征信情况、工作年限、收入情况，房产信息、车辆信息、社保及公积金信息、商业保险信息、企业主信息、纳税信息等（具体以您提供为准）。
                    </div>
                    <div class="indent">
                        2、本人同意并授权贵司可将本人个人信息进行收集、留存、整理、加工分析等（用途：用于提供更好的贷款推荐或货款服务）。
                    </div>
                    <div class="indent">
                        3、我们在获得您的相关数据后将严格保密，将不会用于为您提供贷款服务以外的行为。
                    </div>
                    <div class="indent">
                        4、本人充分认识到财产性信息是私密且业要的信息（本授权书所述的财产性信息包括但不限于个人收入情况、房产信息、车辆信息、社保及公积金信息、商业保险信息等）。本人已经充分理解并知悉提供和使用财产性信息的风险（注：这些风险包括但不限于：纳入这些信息对个人信用评级（评分）、信用报告等结果可能产生不利影响，该等信息由被授权人依法提供给第三方后被他人不当利用的风险，因个人信用状况较好而造成您被第三方推销产品或服务等打扰的风险等）。
                    </div>
                    <div class="indent">
                        5、本人同意贵司及其员工在法律法规许可的范围内通过电话、手机短信等方式与本人取得联系、告知或发送服务相关信息及其他商业电子信息，并为保证服务质量可能对上述电话进行录音。本人在此授权并自愿成为贵司的服务用户，接受本授权书的约束，并可接受贵司的服务。
                    </div>

                    <div class="indent">
                        授权人：{{realName}}
                    </div>
                    <div class="indent">
                        UID：{{uid}}
                    </div>
                    <div class="indent">
                        授权日期：{{date}}
                    </div>
                    <div class="indent weight">
                        三、【个人信息处理规则】
                    </div>
                    <div class="indent weight">
                        使用我们的平台服务时，在点击“立即申请”后，您须按照页面要求填写贷款申请所需的基础信息，我们在收集、存储、分析该等信息后，对在库产品进行匹配，将可能符合您要求及资信情况的产品向您进行展示，您选择并点击确认具体申请的产品/服务后，我们将根据您的授权协助您完成申请（将产品/服务所需要的相关信息传输给合作方或服务提供者），我们不参与该产品/服务的提供与具体细节的审核、贷款的催收等，且不会向您收取任何费用。贷款申请后续所涉及的相关流程包括但不限于资金方的选择、授信审核、签约等，可能需要您自行下载合作方APP或配合其线下完成，我们不再参与，您应了解并遵守合作方的相关规定及隐私政策。授权服务提供者将其合法收集的相关个人借款信息(包括但不限于您的姓名、身份证号、手机号等)传输给我们以便提供给您更好的服务。
                    </div>
                    <div>
                        您点击“立即申请”或“下一步”等相似含义的按钮或者文案时即视为您知悉并同意服务提供者出于上述身份验证目的、明示的处理方式、个人信息的种类范围，并在服务提供者服务期间内，授权我们处理您的个人信息。我们将严格按照授权处理您的个人信息，授权撤回后我们将根据法律法规要求留存您在申请、使用服务过程中产生或提供的相关个人信息并根据业务所需决定存储期限，或对该信息进行删除或匿名化处理，亦或对该数据用于内部数据分析等。同时将不影响授权撤回前基于个人同意已进行的个人信息处理活动的效力。
                    </div>
                    <div>
                        如您不同意授权，请勿点击“立即申请”，同时您将无法继续使用本平台功能，进而影响您使用相应服务体验。<span class="weight">只因您提供的个人信息为我们和合作方提供服务所必须的内容。</span>但这并不影响服务提供者通过其它方式为您提供相应服务，法律法规另有规定的除外。
                    </div>
                    <div>
                        我们将采取法律法规以及与服务提供者约定的必要安全措施，以尽到信息安全保护义务。但您须知悉的是，本功能，无法对服务提供者的信息安全保护能力或其处理行为做任何保证。如您对服务提供者收集、提供、存储、使用您的个人信息有任何疑问，或决定行使法律法规规定的权利，您可以直接联系该服务提供者处理。如您发现您的个人信息权益被侵犯，可点击“投诉”，我们将在能力范围内协助您应对所遇到的侵权。
                    </div>
                    <div class="indent weight">
                        以下为您与我们所签订的个人信息授权书详情，如您同意授权，请点击“勾选”以及“下一步”，您点击的行为代表您已授权在提供产品或服务过程中，在授权范围内使用您的个人信息：
                    </div>
                    <div class="indent weight">
                        1、在申请本产品/服务时，基于身份识别、反欺诈、资信评估等等之目的，您主动通过我们平台页面填写、提交（或授权提交）的基础信息（包括但不限于姓名、身份证号码、身份证照片、贷款需求、目的、月收入概况、工作城市、工作年限、学历、公积金/社保缴存时间、信用卡额度情况、逾期情况、保险投保情况、房产情况、紧急联系人等信息，具体以产品及页面要求为准），以及在后续使用时，不定时按要求向我们或合作方提交的相关信息；
                    </div>
                    <div class="indent weight">
                        2、基于反欺诈、风险防范、应用软件适配之目的，您同意我们自您移动设备获取相关数据（如设备品牌、型号、系统版本、串码、IMEI手机序列（针对安卓用户）、应用编号（针对安卓用户）、应用的唯一标识（针对苹果用户）、IDFA推广用的广告标识（针对苹果用户）、WiFi
                        Mac地址、蓝牙 Mac地址、GPS信息、当前网络类型、ip地址等；
                    </div>
                    <div class="indent weight">
                        3、根据部分产品/服务的申请要求，您授权我们向合法保存有您个人信息的第三方数据源机构进行查询/调取/解析而获取的相关数据，如公积金信息、社保信息，征信机构的征信信息等，具体以您后续的具体授权为准；
                    </div>
                    <div class="indent weight">
                        4、您同意并授权我们以协助您完成申请、协助筛选产品之目的，根据合作方产品/服务之要求，采集、解析、保存、整理、加工以上您提供或授权提供之信息，并在获得您同意后将前述信息传输提供给您申请的产品/服务方；您同时授权该产品/服务方及其合作的第三方在以下用途的范围内存储、分析、评估、使用您的以上信息：
                    </div>
                    <div class="indent weight">
                        （1）审核您授信、贷款等产品/服务申请；
                    </div>
                    <div class="indent weight">
                        （2）对您进行事前、事中、事后的风险评测、贷款管理，包括身份识别、反欺诈测试、资信评估、履约能力测试等；
                    </div>
                    <div class="indent weight">
                        （3）处理您贷后管理事务（含还款通知、催收）；
                    </div>
                    <div class="indent weight">
                        （4）根据您的情况，向您推荐其他产品/服务；
                    </div>
                    <div class="indent weight">
                        （5）用于改进用户体验，创建数据分析模型，为您提供更好的金融服务，并维护和改进这些服务；
                    </div>
                    <div class="indent weight">
                        （6）其他经您本人同意的使用用途。
                    </div>
                    <div class="indent weight">
                        5、在使用我们服务时，合作方可能需要重新采集您的基础信息，为了避免每次采集都需要经过您本人的反复确认而导致的过程繁杂，或者因此给您带来的不便，您同意并授权我们可以直接向合作方或由合作方指定的第三方提供您本人的信息而不需要您再次授权。提供的信息包括但不限于您的姓名、身份证号码、贷款需求、目的、月收入概况、工作城市、工作年限、学历、公积金/社保缴存时间、信用卡额度情况、逾期情况、保险投保情况、房产情况、紧急联系人等您主动提交的个人信息、资产信息、设备信息等。
                    </div>
                    <div>
                        6、您知悉并理解，即便在我们以及第三方服务机构具备足够的数据安全能力并提供足够的安全保护水平的前提下，本人的信息仍可能存在不可控的风险。
                    </div>
                    <div>
                        7、本人声明，本人已充分理解并同意上述相关授权内容，本人自愿签署本授权书，并清晰知晓因此可能产生的一切法律后果。
                    </div>
                    <div class="indent">
                        <span class="weight">本协议是您真实意思表示，并自愿做出上述授权并承担相应法律后果。您确认已完全理解本协议的条款（尤其是黑体字部分）及其他相关说明文件且同意受其约束；</span>
                        自您点击/勾选“确认”、“同意”、“立即申请”按钮或类似按钮，亦或填写资料实际申请服务之日起生效；本协议的订立、生效、履行、解释以及由此产生的所有事项均适用中华人民共和国大陆法律（不包含港澳台法律法规、冲突法等），若您与我们发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交我们住所地法院予以诉讼解决。
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from '@/components/loading';

    export default {
        name: "agreementForeign",
        props: ['productName', 'realName', 'date', 'uid'],
        props: {
            productName: {
                type: String
            },
            realName: {
                type: String
            },
            idCard: {
                type: String
            },
            date: {
                type: String
            },
            uid: {
                type: String
            }
        },
        data() {
            return {
                pageShow: true,
            }
        }, created() {
            /*var realName = this.$route.query.realName;
            if (realName) {
                this.realName = realName;
            }
            var date = this.$route.query.date;
            if (date) {
                this.date = date;
            }
            var productName = this.$route.query.productName;
            if (productName) {
                this.productName = productName;
            }
            var uid = this.$route.query.uid;
            if (uid) {
                this.uid = uid;
            }*/
            console.log(this.realName + "  " + this.date + "  " + this.productName + "  " + this.uid)
        }, methods: {}
    }
</script>

<style scoped>
    * {
        margin: 0rem;
        padding: 0rem;
        line-height: 0.25rem;
    }

    .agreement {
        width: 100%;
        height: 100%;
        background-size: cover;
        padding: 0.1rem 0.15rem 0.3rem;
    }

    .agreement .agree {
        height: 100%;
        margin: 0.1rem 0rem;
        background: #FFFFFF;
        overflow-y: scroll;
    }

    .agreement .agree .title {
        font-size: 0.14rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        text-align: center;
        margin-bottom: 0.1rem;
    }

    .agreement .agree .text {
        font-size: 0.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 0.2rem;
    }

    .indent {
        text-indent: 0.2rem;
    }

    .weight {
        font-weight: 700;
        color: #333;
    }

</style>
